import React, { useEffect, useState } from "react";
import Navbar from "../DashBoardComponents/Navbar";
import Footer from "../DashBoardComponents/Footer";
import Chatbot from "../DashBoardComponents/Chatbot";
import chatbotimage4 from "../assets/images/chatbot4.png";
import chatbotimage3 from "../assets/images/chatbot3.png";
import ChatbotForPatient from "../DashBoardComponents/ChatbotForPatient";
import { fetchStateList, fetCountryList } from "../Redux/actions/commonActions";
import { useDispatch, useSelector } from "react-redux";

function Layout({ children }) {
  const [active, setActive] = useState(false);
  const { patientData } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (patientData && patientData.patientId) {
      const payload = {
        status: 1,
      };
      dispatch(fetCountryList(payload));
      dispatch(fetchStateList(payload));
    }
  }, [dispatch, patientData]);

  const storedLoginResult = localStorage.getItem("patientData");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  return (
    <div className="flex flex-col">
      <div>
        <Navbar />
      </div>
      <div className="pt-[70px]">{children}</div>

      {loginResultObject?.patientId && (
        <div>
          {" "}
          {active ? (
            <ChatbotForPatient setActive={setActive} />
          ) : (
            <div className="chatbot-activate" onClick={() => setActive(true)}>
              <img src={chatbotimage3} alt="chatbot" />
            </div>
          )}
        </div>
      )}
      {!loginResultObject?.patientId && (
        <div>
          {" "}
          {active ? (
            <ChatbotForPatient setActive={setActive} />
          ) : (
            <div className="chatbot-activate" onClick={() => setActive(true)}>
              <img src={chatbotimage3} alt="chatbot" />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Layout;
